import React, {useState} from 'react'
import {useCSVReader} from 'react-papaparse';
import {COLOR_LIST} from "../../../common/constants/color.constant";
import {PRODUCT_DETAIL_KEY, PRODUCT_FIELDS_LIST, PRODUCT_UPLOAD_TABS_LIST} from "../../constants/pod.constant";
import _ from "lodash";
import ProductImageSmall from "./product-image-small";

const productFieldsList = _.orderBy(PRODUCT_FIELDS_LIST, 'label');

const ProductDetailMapping = ({
                                  podDetail,
                                  setPodDetail,
                                  uploadedProductFields,
                                  setUploadedProductFields,
                              }) => {

    const handleFieldChanges = (index, event) => {
        const {name, value} = event.target;

        const existingUploadedProductFields = [...uploadedProductFields];
        existingUploadedProductFields[index][name] = value;
        setUploadedProductFields(existingUploadedProductFields);

        checkIfAllFieldMappingCompleted();
    }

    const checkIfAllFieldMappingCompleted = () => {
        let fieldMappingIncomplete = false;

        _.forEach(uploadedProductFields, (productField) => {
            if (_.isEmpty(productField.attribute)) {
                fieldMappingIncomplete = true;
            }
        });

        if (!fieldMappingIncomplete) {
            const existingPodDetail = {...podDetail};
            existingPodDetail.productFieldMapping = uploadedProductFields;
            setPodDetail(existingPodDetail);
        }
    }

    return (
        <>

            <div className="table-content-container overflow-y-scroll border-y border-gray-50 bg-neutral-100">
                <table className="">
                    <thead className="">
                    <tr>
                        <th className="px-2 py-2 sticky top-0 bg-gray-400 text-white w-64">
                            Label
                        </th>
                        <th className="px-2 py-2 sticky top-0 bg-gray-400 text-white">
                            Attribute
                        </th>
                    </tr>
                    </thead>
                    <tbody className="">
                    {uploadedProductFields?.map((field, index) => (
                        <tr key={`field-${index}`} className="hover:bg-gray-300">
                            <td className="p-2 w-64">
                                <div className="font-bold text-gray-600 pl-4">{field?.label}</div>
                            </td>
                            <td className="">
                                <div className="field-container">
                                    <select
                                        className={`input-field-max ${field?.attribute ? '' : 'error-input-field'}`}
                                        id="attribute"
                                        name="attribute"
                                        value={field?.attribute}
                                        onChange={(event) => {
                                            handleFieldChanges(index, event)
                                        }}>
                                        <option value="">Choose Attribute</option>
                                        {productFieldsList?.map((productField, index) => (
                                            <option key={index}
                                                    value={productField?.attribute}>{productField.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </td>
                        </tr>

                    ))}
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default ProductDetailMapping
